<template>
	<div class="main_holder sections">

        <ul-users-submenu></ul-users-submenu>
		
		<div class="content_holder">
	
			<router-view v-slot="{ Component }">
            <transition name="fade" mode="out-in">
                <component :is="Component" />
            </transition>
            </router-view>
		</div>
	</div>
</template>


<script>
    import UsersSubMenu from './UsersSubMenu.vue';

    export default {
        name: 'Users',
        components: {
            'ul-users-submenu': UsersSubMenu,
        },
        data: function() {
            return {
            }
		},
		computed: {
		}
    }
</script>


<style lang="scss" scoped>
</style>
